import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface Repository {
  id: string;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class RepositoryService {
  private base = '/BPM/API/a/Assets/ContentRepositoryProfiles';
  
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient
  ) { }

  getRepositoryEntryProp(repositoryId: string, entryId: string): Observable<any>{
    let endpoint = this.base + `/${repositoryId}/entries/${entryId}?useUserConnection=true`;
    return this.http.get<any>(endpoint);
  }

  getRepositoryEntryListing(repositoryId: string, entryId: string = "1", fieldIds: string[] = []): Observable<any>{
    let endpoint = this.base + `/${repositoryId}/entrylisting/${entryId}`;
    let postData = {
      fieldIds: fieldIds,
      useUserConnection: true
    }
    return this.http.post<any>(endpoint, postData);
  }

  getEntryFile(repositoryId: string, entryId: string): Observable<any>{
    let endpoint = this.base + `/${repositoryId}/documentfile/${entryId}?useUserConnection=true`;
    return this.http.get<any>(endpoint, {responseType: 'blob' as 'json', observe: 'response'});
  }

  getBulkEntries(repositoryId: string, entryIds: number[], fieldIds: string[] = []){
    let endpoint = this.base + `/${repositoryId}/bulkentries`
    let postData = {
      fieldIds: fieldIds,
      entries: entryIds,
      useUserConnection: true
    }
    return this.http.post<any>(endpoint, postData);
  }

  getRepositoryFields(repositoryId: string): Observable<any>{
    const fieldUrl: string = this.base + `/${repositoryId}/fields`
    return this.http.get<any>(fieldUrl);
  }

  getAll(): Observable<Repository[]> {
    return this.http.get<Repository[]>(this.base);
  }
}
